// extracted by mini-css-extract-plugin
module.exports = {"overlay":"StaffModal_overlay__3YbtE","inputContainer":"StaffModal_inputContainer__1MKRP","text":"StaffModal_text__1rLo7","label":"StaffModal_label__1Pf4b"};